import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to the section named by the URL hash once the page has rendered.
 *
 * The browser resolves `#section` against the document it first receives, which for this SPA is
 * an empty shell — so a deep link like `/rental-terms#no-liability` (the app links the Damage
 * Liability consent straight at that section) silently landed at the top of the page instead.
 */
export const useHashScroll = (): void => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      return;
    }

    // One frame after paint: the section exists by then, and this runs after the browser's own
    // (failed) attempt rather than racing it.
    const frame = window.requestAnimationFrame(() => {
      document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth' });
    });

    return () => { window.cancelAnimationFrame(frame); };
  }, [hash]);
};
